const signUp = {
  companyName: {
    presence: {
      allowEmpty: false,
      message: "Nome da sua empresa é obrigatório."
    },
    length: {
      maximum: 60,
      message: "Nome da sua empresa não pode ter mais de 60 caracteres."
    }
  },
  email: {
    presence: {
      allowEmpty: false,
      message: "E-mail é obrigatório."
    },
    email: {
      message: "E-mail não é válido."
    },
    length: {
      maximum: 100,
      message: "E-mail não pode ter mais de 100 caracteres."
    }
  },
  name: {
    presence: {
      allowEmpty: false,
      message: "Seu nome é obrigatório."
    }
  },
  password: {
    presence: {
      allowEmpty: false,
      message: "Senha para acessar a PDVend é obrigatória."
    },
    length: {
      minimum: 8,
      message: "Senha deve ter no mínimo 8 caracteres."
    }
  },
  confirmPassword: {
    presence: {
      allowEmpty: false,
      message: "Confirmação da Senha é obrigatória."
    },
    equality: {
      attribute: "password",
      message: "Senha e Confirmação da Senha devem ser iguais."
    }
  },
  phone: {
    presence: {
      allowEmpty: false,
      message: "Seu telefone é obrigatório."
    },
    format: {
      pattern: /\d{8,11}/,
      message: "Telefone com formato inválido"
    }
  }
};

export default {
  signUp
};



// WEBPACK FOOTER //
// ./src/core/constraint/sign-up.constraint.js